import { render, staticRenderFns } from "./EditStructure.vue?vue&type=template&id=2543a842&"
import script from "./EditStructure.vue?vue&type=script&lang=js&"
export * from "./EditStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports